export default [
  {
    path: '/employees',
    name: 'employees',
    component: () => import('./UserList.vue')
  },
  {
    path: '/employees/add',
    name: 'addUser',
    component: () => import('./user-form/UserForm.vue')
  },
  {
    path: '/employees/changePassword',
    name: 'changePassword',
    component: () => import('./ChangePassword.vue')
  },
  {
    path: '/employees/:id',
    name: 'userDetails',
    component: () => import('./UserDetails.vue')
  },
  {
    path: '/employees/edit/:id',
    name: 'editUser',
    component: () => import('./user-form/UserForm.vue')
  },
  {
    path: '/employees/edit/:id/:cf',
    name: 'editInvalidEmp',
    component: () => import('./user-form/UserForm.vue')
  }
]
